import { ArrowUpRight } from "lucide-react";
import { CLINIC } from "@/data/clinic";
import Reveal from "./Reveal";

const GoogleMark = () => (
    <svg viewBox="0 0 24 24" className="h-6 w-6" aria-hidden="true">
        <path fill="#4285F4" d="M23.49 12.27c0-.85-.08-1.66-.22-2.45H12v4.64h6.45a5.52 5.52 0 0 1-2.39 3.62v3h3.86c2.26-2.09 3.57-5.16 3.57-8.81z" />
        <path fill="#34A853" d="M12 24c3.24 0 5.96-1.07 7.94-2.92l-3.86-3c-1.07.72-2.44 1.15-4.08 1.15-3.14 0-5.8-2.12-6.75-4.97H1.29v3.1A12 12 0 0 0 12 24z" />
        <path fill="#FBBC05" d="M5.25 14.26a7.2 7.2 0 0 1 0-4.52v-3.1H1.29a12 12 0 0 0 0 10.82l3.96-3.2z" />
        <path fill="#EA4335" d="M12 4.77c1.76 0 3.35.61 4.6 1.8l3.42-3.42A11.98 11.98 0 0 0 12 0 12 12 0 0 0 1.29 6.64l3.96 3.1C6.2 6.89 8.86 4.77 12 4.77z" />
    </svg>
);

export default function GoogleReviews() {
    return (
        <section id="reviews" data-testid="reviews-section" className="border-y border-sand/70 bg-bone py-14 md:py-16">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal>
                    <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
                        <div className="flex items-center gap-4">
                            <span className="rounded-2xl border border-sand bg-cream p-3.5">
                                <GoogleMark />
                            </span>
                            <div>
                                <h2 className="font-serif text-2xl font-medium text-ink md:text-3xl" data-testid="reviews-heading">
                                    Rated by Our Guests on Google
                                </h2>
                                <p className="mt-1 text-sm text-moss">
                                    Reviews live on our verified Google Business Profile — read them exactly as written.
                                </p>
                            </div>
                        </div>
                        <a
                            href={CLINIC.mapsView}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="read-reviews-btn"
                            className="inline-flex shrink-0 items-center gap-2 rounded-full bg-forest px-6 py-3 text-sm font-semibold text-cream transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-forest-deep"
                        >
                            Read Our Google Reviews <ArrowUpRight className="h-4 w-4" />
                        </a>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
